import { events } from '../../events';
import { BaseComponent } from '../../framework/base.component';
import { component } from '../../framework/component.decorator';
import { OnInit } from '../../framework/on-init.interface';
import { button$ } from '../../framework/templating/button.element';
import { icon$, Icons } from '../../framework/templating/icon.element';
import styles from './start-recording-trigger.component.scss';

@component({
  selector: 'app-start-recording-trigger',
  styles,
})
export class StartRecordingTriggerComponent
  extends BaseComponent<StartRecordingTriggerComponent>
  implements OnInit
{
  constructor(
    public icon: Icons = 'record-fill',
    public title = 'Click to start recording'
  ) {
    super();
  }

  async createInitialComponent(): Promise<HTMLElement | HTMLElement[]> {
    return button$(
      {
        onCreate: (element) => {
          element.addEventListener('click', () => this.onClick());
          element.disabled = true;
        },
      },
      [icon$(this.icon)]
    );
  }

  async onInit() {
    events.on(['source-selected'], () =>
      this.doOnFirstChild<HTMLButtonElement>((btn) => (btn.disabled = false))
    );

    events.on('start-recording', () => {
      this.getFirstChild()?.classList.add('recording');
      this.doOnFirstChild<HTMLButtonElement>((btn) => (btn.disabled = true));
    });

    events.on('stop-recording', () => {
      this.getFirstChild()?.classList.remove('recording');
      this.doOnFirstChild<HTMLButtonElement>((btn) => (btn.disabled = true));
    });
  }

  protected onClick() {
    events.emit('start-recording');
  }
}
